// eslint-disable-next-line no-unused-vars
import { Fragment, h } from 'preact';
import { useState } from 'preact/hooks';
import PropTypes from 'prop-types';

const { __ } = wp.i18n;

/**
 * Item component.
 * Used to render all list items consistently.
 *
 * @param {Object} props Props
 * @param {Object} props.item Item object. Required.
 * @param {boolean} props.hidden True if the item is hidden initially, false if not. Default false.
 * @param {string} props.type The type of the input. Radio or checkbox.className
 * @param {string} props.group The string / slug of the group.
 * @return {Object} JSX
 */
const Item = ( props ) => {
	const { item, type, hidden, group, depth, hideCount } = props;
	const { parent } = item;
	const uniqueId = `field-${group}-${item.id}-${item.value}`.toLowerCase().replace( ' ', '_' );
	const [isExpanded, setIsExpanded] = useState( false );

	window.MSRSearch.slot++;

	/**
	 * Handle button toggle.
	 */
	const handleButtonExpandOnClick = () => {
		setIsExpanded( !isExpanded );
	};

	return (
		<li
			hidden={hidden}
			className={`custom-control custom-${type} custom-control--depth-${depth}`}
		>
			<input
				id={uniqueId}
				type={type}
				name={item.name}
				value={item.value}
				className="custom-control-input"
				checked={item.selected}
				data-bi-id={item.value}
				data-bi-cN={item.label}
				data-bi-slot={window.MSRSearch.slot}
				data-bi-type={parent.label}
				data-bi-bhvr="4"
				data-bi-tN="search-facet"
			/>
			<label
				htmlFor={uniqueId}
				className="custom-control-label"
				aria-label={`${item.label} (with ${item.count} items)`}
			>
				<span className="custom-control-glyph"></span>
				{item.label}&nbsp;
				{!!item.count && !hideCount ? ( <span>({item.count})</span> ) : null}
			</label>
			{item.children.length ? (
				<>
					<button
						aria-controls={`${item.id}-expanded`}
						aria-expanded={isExpanded}
						className="btn btn-link btn-sm text-decoration-none ml-auto mb-0 p-0 text-black"
						onClick={handleButtonExpandOnClick}
						type="button">
						<span className="glyph-prepend glyph-prepend-chevron-down" hidden={!isExpanded} />
						<span className="glyph-prepend glyph-prepend-chevron-right" hidden={isExpanded} />
						<span className="sr-only">{__( `Toggle additional items for: ${item.label}`, 'ms-research' )}</span>
					</button>
					<div
						aria-hidden={!isExpanded}
						className="custom-control-children mt-2 w-100"
						hidden={!isExpanded}
						id={`${item.id}-expanded`}>
						{item.children.map( ( childItem ) => (
							<Item
								item={childItem}
								key={childItem.id}
								group={group}
								type={type}
								depth={depth + 1} />
						) )}
					</div>
				</>
			) : null}
		</li>
	);
};

Item.defaultProps = {
	hidden: false,
	depth: 0,
	hideCount: false,
};

Item.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	item: PropTypes.object.isRequired,
	hidden: PropTypes.bool,
	type: PropTypes.string.isRequired,
	group: PropTypes.string.isRequired,
	depth: PropTypes.number,
	hideCount: PropTypes.bool,
};

export default Item;
